// import { ENABLE_POTIC_RETAINER_TYPE } from "../../pages/DiffRetainer/utils";
import { IMPRESSION_TYPE } from '../../pages/hooks/DiffRetainerHooks/useRetainerRequestForm';
import { questions } from './Question';
import * as yup from 'yup';
const isVeneerShieldRetainer = (retainerType) => {
    return ['ecodontRetainerWithVeneerShield_3set', 'ecodontRetainerWithVeneerShield_1set'].includes(retainerType);
};
const isFixedWireYes = (fixedWire) => {
    return fixedWire === true || fixedWire === 'true';
};
export const getSingleImpressionTypeSchema = (required, isTab = false) => {
    return yup.object().shape({
        archPosition: yup.string().required(required),
        fixedWire: yup.boolean().required(required), // <= Q2
        archAndQuantity: yup.string().required(required), // <= Q3
        bleachingRetainersSelect: yup // <= Q3's selection
            .string()
            .when(['archAndQuantity', questions[2].name], (v, _) => {
                //Explain: index 0 refer to archAndQuantity, index 1 refer to questions[2].name
                if (v[0] === 'bleachingRetainers' && v[1] === 'false') {
                    return yup.string().required(required);
                }
                return _.nullable();
            }),

        palatalWireSelect: yup // <= Q3's selection
            .string()
            .when(['archAndQuantity', questions[2].name], (v, _) => {
                //Explain: index 0 refer to archAndQuantity, index 1 refer to questions[2].name
                if (v[0] === 'fixedPalatalWire' && v[1] === 'false') {
                    return yup.string().required(required);
                }
                return _.nullable();
            }),

        jigPlacementSelect: yup // <= Q3's selection
            .string()
            .when(['archAndQuantity', questions[2].name], (v, _) => {
                //Explain: index 0 refer to archAndQuantity, index 1 refer to questions[2].name
                if (v[0] === 'fixedPalatalWire' && v[1] === 'false') {
                    return yup.string().required(required);
                }
                return _.nullable();
            }),
        LowTrimlineAreaSelect_3: yup // <= Q3's selection
            .string()
            .when(['archAndQuantity', questions[2].name], (v, _) => {
                //Explain: index 0 refer to archAndQuantity, index 1 refer to questions[2].name
                if (v[0] === 'ecodontRetainerWithVeneerShield_3set' && v[1] === 'false') {
                    return yup.string().required(required);
                }
                return _.nullable();
            }),
        LowTrimlineAreaSelect_1: yup // <= Q3's selection
            .string()
            .when(['archAndQuantity', questions[2].name], (v, _) => {
                //Explain: index 0 refer to archAndQuantity, index 1 refer to questions[2].name
                if (v[0] === 'ecodontRetainerWithVeneerShield_1set' && v[1] === 'false') {
                    return yup.string().required(required);
                }
                return _.nullable();
        }),
        smartFitWireSelect: yup // <= Q3's selection
            .string()
            .when(['archAndQuantity', questions[2].name], (v, _) => {
                //Explain: index 0 refer to archAndQuantity, index 1 refer to questions[2].name
                if (v[0] === 'MDLSmartFitRetainersWithWire' && v[1] === 'false') {
                    return yup.string().required(required);
                }
                return _.nullable();
            }),

        ecodontWireSelect: yup // <= Q3's selection
            .string()
            .when(['archAndQuantity', questions[2].name], (v, _) => {
                //Explain: index 0 refer to archAndQuantity, index 1 refer to questions[2].name
                if (v[0] === 'ecodontRetainersWithWire' && v[1] === 'false') {
                    return yup.string().required(required);
                }
                return _.nullable();
            }),

        ecodontRetainerWithWire_1setSelect: yup // <= Q3's selection
            .string()
            .when(['archAndQuantity', questions[2].name], (v, _) => {
                //Explain: index 0 refer to archAndQuantity, index 1 refer to questions[2].name
                if (v[0] === 'ecodontRetainerWithWire_1set' && v[1] === 'false') {
                    return yup.string().required(required);
                }
                return _.nullable();
            }),

        occlusalBiteRampQuestion: yup
            .string() // <= Q4
            .when('archAndQuantity', (v, _) => {
                const value = v[0]; // archAndQuantity's value
                if (['MDLSmartFitRetainers', 'MDLSmartFitRetainersWithWire'].includes(value)) {
                    return yup.string().required(required);
                }
                return _.nullable();
            }),

        // clearRetainerDesignUpper:yup.boolean() // <= Q5A
        // .when(['archPosition', 'archAndQuantity'] , (v , _) => {
        //   const value = v[0]
        //   const retainerType = v[1]
        //   if (['ecodontRetainersWithWire', 'MDLSmartFitRetainersWithWire', 'fixedPalatalWire'].includes(retainerType)) {
        //     if(value === IMPRESSION_TYPE.UPPER || value === IMPRESSION_TYPE.UPPER_AND_LOWER) {
        //       return yup.boolean().required("Required").oneOf([true] , "Required")
        //     }
        //   }
        // }),

        clearRetainerDesignUpperOption: yup.string().nullable().test(
            'required-upper-veneer-shield-design',
            required,
            function (value) {
                const { archPosition, archAndQuantity, fixedWire } = this.parent;

                if (
                    isFixedWireYes(fixedWire) &&
                    isVeneerShieldRetainer(archAndQuantity) &&
                    [IMPRESSION_TYPE.UPPER, IMPRESSION_TYPE.UPPER_AND_LOWER].includes(archPosition)
                ) {
                    return !!value;
                }

                return true;
            }
        ), // <= Q5A's option
        // .when('clearRetainerDesignUpper', (v, _) => {
        //   const value = v[0]
        //   if(value) {
        //     return yup.string().required("Required")
        //   }
        // })
        // clearRetainerDesignLower:yup.boolean() // <= Q5B
        // .when(['archPosition', 'archAndQuantity'] , (v , _) => {
        //   const value = v[0]
        //   const retainerType = v[1]
        //   if(['ecodontRetainersWithWire', 'MDLSmartFitRetainersWithWire', 'fixedPalatalWire'].includes(retainerType)) {
        //     if(value === IMPRESSION_TYPE.LOWER || value === IMPRESSION_TYPE.UPPER_AND_LOWER) {
        //       return yup.boolean().required("Required").oneOf([true] , "Required")
        //     }
        //   }
        // }),

        clearRetainerDesignLowerOption: yup.string().nullable().test(
            'required-lower-veneer-shield-design',
            required,
            function (value) {
                const { archPosition, archAndQuantity, fixedWire } = this.parent;

                if (
                    isFixedWireYes(fixedWire) &&
                    isVeneerShieldRetainer(archAndQuantity) &&
                    [IMPRESSION_TYPE.LOWER, IMPRESSION_TYPE.UPPER_AND_LOWER].includes(archPosition)
                ) {
                    return !!value;
                }

                return true;
            }
        ), // <= Q5B's option
        // .when('clearRetainerDesignLower', (v, _) => {
        //   const value = v[0]
        //   if(value) {
        //     return yup.string().required("Required")
        //   }
        // })
        // clearRetainerDesignUpperForSecondSet:yup.boolean(), // <= Q6A
        // clearRetainerDesignUpperOptionForSecondSet:yup.string() // <= Q6A's option
        // .when('clearRetainerDesignUpperForSecondSet' , (v,_) => {
        //   const value = v[0]
        //   if(value) {
        //     return yup.string().required(required)
        //   }
        // })
        // ,

        // clearRetainerDesignLowerForSecondSet:yup.boolean(), // <= Q6B
        // clearRetainerDesignLowerOptionForSecondSet:yup.string() // <= Q6B's option
        // .when('clearRetainerDesignLowerForSecondSet' , (v,_) => {
        //   const value = v[0]
        //   if(value) {
        //     return yup.string().required("Required")
        //   }
        // })
        // ,

        pontics: yup.boolean(), // <= Q7
        pontic: yup.string(),
        // .when('archAndQuantity' , (v) => {
        //   const value = v[0]
        //   if(ENABLE_POTIC_RETAINER_TYPE.includes(value) ) {
        //     return yup.string().required(required)
        //   }
        // })
        ponticColor: yup.string().when('pontic', (v, _) => {
            const value = v[0];
            if (value === 'colourPonticRequired') {
                return _.required('Pontic color is required.');
            }
            return _.nullable(); // Return the original schema if the condition is not met
        }),
        impressionOption: yup.string().when((v, _) => {
            if (!isTab) {
                return yup.string().required(required);
            }
            return _.nullable();
        }),
    });
};

export const getUpperAndLowerImpressionTypeSchema = (required, isTab = false) => {
    return yup.object().shape({
        // upper form field
        // UpperArchPosition: yup.string().required('Required'),
        UpperFixedWire: yup.boolean().required(required), // <= Q2
        UpperArchAndQuantity: yup.string().required(required), // <= Q3
        UpperBleachingRetainersSelect: yup // <= Q3's selection
            .string()
            .when(['UpperArchAndQuantity', 'UpperFixedWire'], (v, _) => {
                //Explain: index 0 refer to archAndQuantity, index 1 refer to questions[2].name
                if (v[0] === 'bleachingRetainers' && v[1] === 'false') {
                    return yup.string().required(required);
                }
                return _.nullable();
            }),

        UpperPalatalWireSelect: yup // <= Q3's selection
            .string()
            .when(['UpperArchAndQuantity', 'UpperFixedWire'], (v, _) => {
                //Explain: index 0 refer to archAndQuantity, index 1 refer to questions[2].name
                if (v[0] === 'fixedPalatalWire' && v[1] === 'false') {
                    return yup.string().required(required);
                }
                return _.nullable();
            }),

        UpperJigPlacementSelect: yup // <= Q3's selection
            .string()
            .when(['archAndQuantity', questions[2].name], (v, _) => {
                //Explain: index 0 refer to archAndQuantity, index 1 refer to questions[2].name
                if (v[0] === 'fixedPalatalWire' && v[1] === 'false') {
                    return yup.string().required(required);
                }
                return _.nullable();
            }),
        UpperLowTrimlineAreaSelect_3: yup // <= Q3's selection
            .string()
            .when(['UpperArchAndQuantity', 'UpperFixedWire'], (v, _) => {
                //Explain: index 0 refer to archAndQuantity, index 1 refer to questions[2].name
                if (v[0] === 'ecodontRetainerWithVeneerShield_3set' && v[1] === 'false') {
                    return yup.string().required(required);
                }
                return _.nullable();
            }),
        UpperLowTrimlineAreaSelect_1: yup // <= Q3's selection
            .string()
            .when(['UpperArchAndQuantity', 'UpperFixedWire'], (v, _) => {
                //Explain: index 0 refer to archAndQuantity, index 1 refer to questions[2].name
                if (v[0] === 'ecodontRetainerWithVeneerShield_1set' && v[1] === 'false') {
                    return yup.string().required(required);
                }
                return _.nullable();
        }),
        UpperSmartFitWireSelect: yup // <= Q3's selection
            .string()
            .when(['UpperArchAndQuantity', 'UpperFixedWire'], (v, _) => {
                //Explain: index 0 refer to archAndQuantity, index 1 refer to questions[2].name
                if (v[0] === 'MDLSmartFitRetainersWithWire' && v[1] === 'false') {
                    return yup.string().required(required);
                }
                return _.nullable();
            }),

        // UpperFixedPalatalWireSelect: yup // <= Q3's selection
        // .string()
        // .when(['UpperArchAndQuantity', 'UpperFixedWire'], (v, _) => {
        //   //Explain: index 0 refer to archAndQuantity, index 1 refer to questions[2].name
        //   if (v[0] === 'fixedPalatalWire' && v[1] === 'false') {
        //     return yup.string().required(required)
        //   }
        // }),

        UpperEcodontWireSelectWireSelect: yup // <= Q3's selection
            .string()
            .when(['UpperArchAndQuantity', 'UpperFixedWire'], (v, _) => {
                //Explain: index 0 refer to archAndQuantity, index 1 refer to questions[2].name
                if (v[0] === 'ecodontRetainersWithWire' && v[1] === 'false') {
                    return yup.string().required(required);
                }
                return _.nullable();
            }),

        UpperEcodontRetainerWithWire_1setWireSelect: yup // <= Q3's selection
            .string()
            .when(['UpperArchAndQuantity', 'UpperFixedWire'], (v, _) => {
                //Explain: index 0 refer to archAndQuantity, index 1 refer to 'LowerFixedWire'
                if (v[0] === 'ecodontRetainerWithWire_1set' && v[1] === 'false') {
                    return yup.string().required(required);
                }
                return _.nullable();
            }),

        UpperOcclusalBiteRampQuestion: yup
            .string() // <= Q4
            .when('UpperArchAndQuantity', (v, _) => {
                const value = v[0]; // archAndQuantity's value
                if (['MDLSmartFitRetainers', 'MDLSmartFitRetainersWithWire'].includes(value)) {
                    return yup.string().required(required);
                }
                return _.nullable();
            }),

        // UpperClearRetainerDesignUpper:yup.boolean() // <= Q5A
        // .when(['UpperArchPosition', 'UpperArchAndQuantity'] , (v , _) => {
        //   const value = v[0]
        //   const retainerType = v[1]
        //   if (['ecodontRetainersWithWire', 'MDLSmartFitRetainersWithWire', 'fixedPalatalWire'].includes(retainerType)) {
        //     if(value === IMPRESSION_TYPE.UPPER || value === IMPRESSION_TYPE.UPPER_AND_LOWER) {
        //       return yup.boolean().required("Required")
        //     }
        //   }
        // }),

        UpperClearRetainerDesignUpperOption: yup.string().nullable().test(
            'required-upper-veneer-shield-design',
            required,
            function (value) {
                const { UpperArchAndQuantity, UpperFixedWire } = this.parent;

                if (isFixedWireYes(UpperFixedWire) && isVeneerShieldRetainer(UpperArchAndQuantity)) {
                    return !!value;
                }

                return true;
            }
        ), // <= Q5A's option
        // .when('UpperClearRetainerDesignUpper', (v, _) => {
        //   const value = v[0]
        //   if(value) {
        //     return yup.string().required("Required")
        //   }
        // })
        // UpperClearRetainerDesignLower:yup.boolean() // <= Q5B
        // .when(['UpperArchPosition', 'UpperArchAndQuantity'] , (v , _) => {
        //   const value = v[0]
        //   const retainerType = v[1]
        //   if(['ecodontRetainersWithWire', 'MDLSmartFitRetainersWithWire', 'fixedPalatalWire'].includes(retainerType)) {
        //     if(value === IMPRESSION_TYPE.LOWER || value === IMPRESSION_TYPE.UPPER_AND_LOWER) {
        //       return yup.boolean().required("Required")
        //     }
        //   }
        // }),

        UpperClearRetainerDesignLowerOption: yup.string(), // <= Q5B's option
        // .when('UpperClearRetainerDesignLower', (v, _) => {
        //   const value = v[0]
        //   if(value) {
        //     return yup.string().required("Required")
        //   }
        // })
        // UpperClearRetainerDesignUpperForSecondSet:yup.boolean(), // <= Q6A
        // UpperClearRetainerDesignUpperOptionForSecondSet:yup.string() // <= Q6A's option
        // .when('UpperClearRetainerDesignUpperForSecondSet' , (v,_) => {
        //   const value = v[0]
        //   if(value) {
        //     return yup.string().required(required)
        //   }
        //   return _.nullable()
        // }),

        // UpperClearRetainerDesignLowerForSecondSet:yup.boolean(), // <= Q6B
        // UpperClearRetainerDesignLowerOptionForSecondSet:yup.string() // <= Q6B's option
        // .when('UpperClearRetainerDesignLowerForSecondSet' , (v,_) => {
        //   const value = v[0]
        //   if(value) {
        //     return yup.string().required("Required")
        //   }
        // })
        // ,

        UpperPontics: yup.boolean(), // <= Q7
        UpperPontic: yup.string(),
        // .when('UpperArchAndQuantity' , (v) => {
        //   const value = v[0]
        //   if(ENABLE_POTIC_RETAINER_TYPE.includes(value) ) {
        //     return yup.string().required(required)
        //   }
        // })
        UpperPonticColor: yup.string().when('UpperPontic', (v, _) => {
            const value = v[0];
            if (value && value.length > 0 && value === 'colourPonticRequired') {
                return yup.string().required(required);
            }
            return _.nullable();
        }),
        // lower form field
        // LowerArchPosition: yup.string().required(required),
        LowerFixedWire: yup.boolean().required(required), // <= Q2
        LowerArchAndQuantity: yup.string().required(required), // <= Q3
        LowerBleachingRetainersSelect: yup // <= Q3's selection
            .string()
            .when(['LowerArchAndQuantity', 'LowerFixedWire'], (v, _) => {
                //Explain: index 0 refer to archAndQuantity, index 1 refer to 'LowerFixedWire'
                if (v[0] === 'bleachingRetainers' && v[1] === 'false') {
                    return yup.string().required(required);
                }
                return _.nullable();
            }),

        // LowerFixedPalatalWireSelect: yup // <= Q3's selection
        //   .string()
        //   .when(['LowerArchAndQuantity', 'LowerFixedWire'], (v, _) => {
        //     //Explain: index 0 refer to archAndQuantity, index 1 refer to 'LowerFixedWire'
        //     if (v[0] === 'LowerFixedPalatalWire' && v[1] === 'false') {
        //       return yup.string().required(required)
        //     }
        //   }),

        LowerPalatalWireSelect: yup // <= Q3's selection
            .string()
            .when(['LowerArchAndQuantity', 'LowerFixedWire'], (v, _) => {
                //Explain: index 0 refer to archAndQuantity, index 1 refer to 'LowerFixedWire'
                if (v[0] === 'fixedPalatalWire' && v[1] === 'false') {
                    return yup.string().required(required);
                }
                return _.nullable();
            }),

        LowerJigPlacementSelect: yup // <= Q3's selection
            .string()
            .when(['archAndQuantity', questions[2].name], (v, _) => {
                //Explain: index 0 refer to archAndQuantity, index 1 refer to questions[2].name
                if (v[0] === 'fixedPalatalWire' && v[1] === 'false') {
                    return yup.string().required(required);
                }
                return _.nullable();
            }),
        LowerLowTrimlineAreaSelect_3: yup // <= Q3's selection
            .string()
            .when(['LowerArchAndQuantity', 'LowerFixedWire'], (v, _) => {
                //Explain: index 0 refer to archAndQuantity, index 1 refer to questions[2].name
                if (v[0] === 'ecodontRetainerWithVeneerShield_3set' && v[1] === 'false') {
                    return yup.string().required(required);
                }
                return _.nullable();
            }),
        LowerLowTrimlineAreaSelect_1: yup // <= Q3's selection
            .string()
            .when(['LowerArchAndQuantity', 'LowerFixedWire'], (v, _) => {
                //Explain: index 0 refer to archAndQuantity, index 1 refer to questions[2].name
                if (v[0] === 'ecodontRetainerWithVeneerShield_1set' && v[1] === 'false') {
                    return yup.string().required(required);
                }
                return _.nullable();
        }),
        LowerSmartFitWireSelect: yup // <= Q3's selection
            .string()
            .when(['LowerArchAndQuantity', 'LowerFixedWire'], (v, _) => {
                //Explain: index 0 refer to archAndQuantity, index 1 refer to 'LowerFixedWire'
                if (v[0] === 'MDLSmartFitRetainers' && v[1] === 'false') {
                    return yup.string().required(required);
                }
                return _.nullable();
            }),

        LowerEcodontWireSelectWireSelect: yup // <= Q3's selection
            .string()
            .when(['LowerArchAndQuantity', 'LowerFixedWire'], (v, _) => {
                //Explain: index 0 refer to archAndQuantity, index 1 refer to 'LowerFixedWire'
                if (v[0] === 'ecodontRetainersWithWire' && v[1] === 'false') {
                    return yup.string().required(required);
                }
                return _.nullable();
            }),

        LowerEcodontRetainerWithWire_1setWireSelect: yup // <= Q3's selection
            .string()
            .when(['LowerArchAndQuantity', 'LowerFixedWire'], (v, _) => {
                //Explain: index 0 refer to archAndQuantity, index 1 refer to 'LowerFixedWire'
                if (v[0] === 'ecodontRetainerWithWire_1set' && v[1] === 'false') {
                    return yup.string().required(required);
                }
                return _.nullable();
            }),

        LowerOcclusalBiteRampQuestion: yup
            .string() // <= Q4
            .when('LowerArchAndQuantity', (v, _) => {
                const value = v[0]; // archAndQuantity's value
                if (['MDLSmartFitRetainers', 'MDLSmartFitRetainersWithWire'].includes(value)) {
                    return yup.string().required(required);
                }
                return _.nullable();
            }),

        // LowerClearRetainerDesignUpper:yup.boolean() // <= Q5A
        // .when(['LowArchPosition', 'LowArchAndQuantity'] , (v , _) => {
        //   const value = v[0]
        //   const retainerType = v[1]
        //   if (['ecodontRetainersWithWire', 'MDLSmartFitRetainersWithWire', 'fixedPalatalWire'].includes(retainerType)) {
        //     if(value === IMPRESSION_TYPE.UPPER || value === IMPRESSION_TYPE.UPPER_AND_LOWER) {
        //       return yup.boolean().required("Required")
        //     }
        //   }
        // }),

        // LowerClearRetainerDesignUpperOption:yup.string() // <= Q5A's option
        // .when('LowerClearRetainerDesignUpper', (v, _) => {
        //   const value = v[0]
        //   if(value) {
        //     return yup.string().required("Required")
        //   }
        // }),

        LowerClearRetainerDesignLower: yup
            .boolean() // <= Q5B
            .when(['LowerArchPosition', 'LowerArchAndQuantity'], (v, _) => {
                const value = v[0];
                const retainerType = v[1];
                if (
                    ['ecodontRetainersWithWire', 'MDLSmartFitRetainersWithWire', 'fixedPalatalWire'].includes(
                        retainerType
                    )
                ) {
                    if (value === IMPRESSION_TYPE.LOWER || value === IMPRESSION_TYPE.UPPER_AND_LOWER) {
                        return yup.boolean().required(required);
                    }
                }
                return _.nullable();
            }),

        LowerClearRetainerDesignLowerOption: yup.string().nullable().test(
            'required-lower-veneer-shield-design',
            required,
            function (value) {
                const { LowerArchAndQuantity, LowerFixedWire } = this.parent;

                if (isFixedWireYes(LowerFixedWire) && isVeneerShieldRetainer(LowerArchAndQuantity)) {
                    return !!value;
                }

                return true;
            }
        ),

        // LowerClearRetainerDesignUpperForSecondSet:yup.boolean(), // <= Q6A
        // LowerClearRetainerDesignUpperOptionForSecondSet:yup.string() // <= Q6A's option
        // .when('LowerClearRetainerDesignUpperForSecondSet' , (v,_) => {
        //   const value = v[0]
        //   if(value) {
        //     return yup.string().required(required)
        //   }
        //   return _.nullable()
        // }),

        // LowerClearRetainerDesignLowerForSecondSet:yup.boolean(), // <= Q6B
        // LowerClearRetainerDesignLowerOptionForSecondSet:yup.string() // <= Q6B's option
        // .when('LowerClearRetainerDesignLowerForSecondSet' , (v,_) => {
        //   const value = v[0]
        //   if(value) {
        //     return yup.string().required(required)
        //   }
        //   return _.nullable()
        // }),

        LowerPontics: yup.boolean(), // <= Q7,
        LowerPontic: yup.string(),
        // .when('LowerArchAndQuantity' , (v) => {
        //   const value = v[0]
        //   if(ENABLE_POTIC_RETAINER_TYPE.includes(value) ) {
        //     return yup.string().required(required)
        //   }
        // })
        LowerPonticColor: yup.string().when('LowerPontic', (v, _) => {
            const value = v[0];
            if (value && value.length > 0 && value === 'colourPonticRequired') {
                return yup.string().required(required);
            }
            return _.nullable();
        }),
        impressionOption: yup.string().when((v, _) => {
            if (!isTab) {
                return yup.string().required(required);
            }
            return _.nullable();
        }),
    });
};
